module.exports = __webpack_public_path__ + "static/media/startup.ff772a43.jpeg";